var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-show=\"directiveCtrl.scrollTowardRight\" ng-click=\"directiveCtrl.showMore()\" class=\"side-scroll-hint\">More →</div><div ng-hide=\"directiveCtrl.scrollTowardRight\" ng-click=\"directiveCtrl.backToStart()\" class=\"side-scroll-hint\">← Back</div><div class=\"side-scroll-hint-container\"><ng-transclude></ng-transclude></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/directives/side-scroll-hint.jade
 ** module id = 3539
 ** module chunks = 3
 **/